import { ClassicJackpot, Live, PlayingCards2, Roulette, Slots, Trending } from '@shared/icons';
import { ROUTES } from '@shared/utils';
import type { CategoryType } from './types';

const { LIVE_LOTTERY, LIVE_BLACKJACK, LIVE_ROULETTE, GAME_SHOWS, ASIAN_GAMES, LIVE_SLOTS } = ROUTES.LIVE_CASINO;

const liveCasinoCategories: CategoryType[] = [
  {
    id: 'lottery',
    slug: LIVE_LOTTERY,
    icon: Trending,
    trackName: 'Lottery',
  },
  {
    id: 'blackjack',
    slug: LIVE_BLACKJACK,
    icon: PlayingCards2,
    trackName: 'Blackjack',
  },
  {
    id: 'roulette',
    slug: LIVE_ROULETTE,
    icon: Roulette,
    trackName: 'Roulette',
  },
  {
    id: 'game_shows',
    slug: GAME_SHOWS,
    icon: Live,
    trackName: 'Game shows',
  },
  {
    id: 'asian_games',
    slug: ASIAN_GAMES,
    icon: ClassicJackpot,
    trackName: 'Asian games',
  },
  {
    id: 'slots',
    slug: LIVE_SLOTS,
    icon: Slots,
    trackName: 'Slots',
  },
];

export { liveCasinoCategories };
